import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../Footer";
import BannerStudentImage from "../../assets/tutor_web_student_banner.jpg";
import React from "react";
import FormModal from "../FormModal";
import { motion } from "framer-motion";
import NavBar from "../Navbar";
import styled from "styled-components";
import TelephoneImg from "../../assets/telephone_2.png";

export default function VaranasiPage() {
  const [isModalOpen, setIsModalOpen] = useState(false); 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  // Carefully positioned circles with vibrant colors
  const circles = [
    // Top left cluster
    {
      id: 1,
      size: 250,
      top: 12,
      left: 5,
      opacity: 0.8,
      color: "rgba(99, 102, 241, 0.2)",
    },
    {
      id: 2,
      size: 180,
      top: 17,
      left: 20,
      opacity: 0.6,
      color: "rgba(236, 72, 153, 0.15)",
    },

    // Top right cluster
    {
      id: 3,
      size: 220,
      top: 25,
      left: 85,
      opacity: 0.7,
      color: "rgba(14, 165, 233, 0.2)",
    },
    {
      id: 4,
      size: 150,
      top: 30,
      left: 65,
      opacity: 0.5,
      color: "rgba(245, 158, 11, 0.15)",
    },

    // Middle left
    {
      id: 5,
      size: 200,
      top: 50,
      left: 15,
      opacity: 0.6,
      color: "rgba(139, 92, 246, 0.15)",
    },

    // Middle right
    {
      id: 6,
      size: 180,
      top: 60,
      left: 80,
      opacity: 0.5,
      color: "rgba(20, 184, 166, 0.15)",
    },

    // Bottom left
    {
      id: 7,
      size: 220,
      top: 85,
      left: 10,
      opacity: 0.7,
      color: "rgba(244, 63, 94, 0.15)",
    },

    // Bottom right
    {
      id: 8,
      size: 250,
      top: 90,
      left: 85,
      opacity: 0.8,
      color: "rgba(59, 130, 246, 0.2)",
    },

    // Center accents
    {
      id: 9,
      size: 100,
      top: 40,
      left: 40,
      opacity: 0.4,
      color: "rgba(234, 179, 8, 0.1)",
    },
    {
      id: 10,
      size: 120,
      top: 70,
      left: 60,
      opacity: 0.4,
      color: "rgba(220, 38, 38, 0.1)",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Tutor Kendra - Varanasi</title>
        <meta
          name="Best Tutors in Varanasi"
          content="Find Home tuition near me in Varanasi. Join home tuition near you in Varanasi."
        />
      </Helmet>
      <main className="relative w-screen overflow-x-hidden">
        {/* Circle Background for entire page */}
        <CircleContainer>
          {circles.map((circle) => (
            <Circle
              key={circle.id}
              size={circle.size}
              top={circle.top}
              left={circle.left}
              opacity={circle.opacity}
              color={circle.color}
            />
          ))}
        </CircleContainer>

        <div className="relative z-10">
          <NavBar showSwitch={false} />

          {/* Hero Section */}
          <StyledSection>
            <div className="wrapper max-w-7xl mx-auto px-4 text-center relative z-10">
              <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-6 drop-shadow-lg text-indigo-900">
                Discover Top Home Tutors in Varanasi with Tutor Kendra
              </h1>
              <p className="text-lg md:text-2xl mb-8 font-light max-w-2xl mx-auto drop-shadow-md text-indigo-800">
                Unleash your academic potential with personalized tutoring
                tailored for every student in Varanasi!
              </p>
              <button
                onClick={() => setIsModalOpen(true)}
                className="inline-block bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-indigo-700 hover:to-purple-700 transition shadow-lg"
              >
                Find a Tutor Now
              </button>
            </div>
          </StyledSection>

          {/* Telephone Number */}
          <div className="block md:hidden">
            <section className="py-2 flex justify-center items-center relative z-10 w-screen overflow-hidden ">
              {/* Image on the left */}
              <div className="">
                <img
                  src={TelephoneImg}
                  alt="Varanasi Tutoring Banner"
                  className="w-[100px] object-cover  rounded-[40px]"
                />
              </div>

              {/* Text on the right */}
              <div className="">
                <div className="flex flex-col items-center md:items-start">
                  <p className="text-lg md:text-2xl mb-4 font-light max-w-2xl mx-auto md:mx-0 text-indigo-800">
                    Need help? Call us on:
                  </p>
                  <a
                    href="tel:+916388204164"
                    className="font-bold text-3xl transition-colors inline-block"
                  >
                    +916388204164
                  </a>
                </div>
              </div>
            </section>
          </div>

          {/* Banner Image */}
          <section className="py-8 flex justify-center items-center relative z-10">
            <img
              src={BannerStudentImage}
              alt="Varanasi Tutoring Banner"
              className="w-[350px] md:w-[400px] lg:w-[600px] xl:w-[1200px] h-auto object-cover mx-8 rounded-[40px]"
            />
          </section>

          <div className="overflow-hidden relative z-10">
            {/* Why Tutor Kendra Section */}
            <motion.section
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeIn}
              className="py-20 relative"
            >
              <div className="container mx-auto px-4">
                <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">
                  Why Tutor Kendra Shines in Varanasi
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  {[
                    {
                      title: "Expert Tutors",
                      desc: "Handpicked, qualified tutors from Varanasi's hubs like BHU Lanka, Shivpur, and Sarnath.",
                      icon: "📚",
                      bg: "from-blue-50 to-indigo-50",
                      text: "text-blue-600",
                    },
                    {
                      title: "Personalized Learning",
                      desc: "Custom lessons crafted to match your child's unique pace and style.",
                      icon: "✏️",
                      bg: "from-purple-50 to-pink-50",
                      text: "text-purple-600",
                    },
                    {
                      title: "Flexible Scheduling",
                      desc: "Learn on your terms with timings that fit Varanasi's busy life.",
                      icon: "⏰",
                      bg: "from-amber-50 to-orange-50",
                      text: "text-amber-600",
                    },
                  ].map((item, index) => (
                    <motion.div
                      key={index}
                      className={`bg-gradient-to-br ${item.bg} p-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 border border-white`}
                      whileHover={{ scale: 1.05 }}
                    >
                      <div className="text-4xl mb-4">{item.icon}</div>
                      <h3 className={`text-xl font-semibold ${item.text} mb-3`}>
                        {item.title}
                      </h3>
                      <p className="text-gray-600">{item.desc}</p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </motion.section>

            {/* Call to Action Section */}
            <motion.section
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeIn}
              className="py-20 bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-center relative overflow-hidden"
            >
              <div className="absolute inset-0 opacity-20 bg-[url('https://source.unsplash.com/random/1600x900/?education')] bg-cover bg-center"></div>
              <div className="relative container mx-auto px-4 z-10">
                <h2 className="text-4xl md:text-5xl font-bold mb-6 drop-shadow-lg">
                  Ready to Elevate Your Learning?
                </h2>
                <p className="text-lg md:text-xl mb-8 max-w-2xl mx-auto drop-shadow-md">
                  Join forces with Varanasi's top tutors and ignite your
                  academic success today!
                </p>
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="px-8 py-4 bg-white text-indigo-600 font-semibold rounded-full shadow-xl hover:bg-indigo-100 hover:scale-105 transform transition-all duration-300"
                >
                  Start Your Journey
                </button>
              </div>
            </motion.section>

            <FormModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              activeTab="student"
            />
          </div>

          <Footer />
        </div>
      </main>
    </>
  );
}

const StyledSection = styled.section`
  position: relative;
  overflow: hidden;
  padding-top: 12rem;
  padding-bottom: 4rem;
  // color: #000000;
  // background: rgba(255, 255, 255, 0.7);
  // backdrop-filter: blur(5px);
`;

const CircleContainer = styled.div`
  // position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
`;

const Circle = styled.div`
  position: absolute;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  background: ${(props) => props.color};
  border-radius: 50%;
  top: ${(props) => props.top}%;
  left: ${(props) => props.left}%;
  opacity: ${(props) => props.opacity};
  transform: translate(-50%, -50%);
  pointer-events: none;
  // filter: blur(30px);
`;
